import React, { useState, FormEvent, useEffect } from "react";

import { Button } from "@app/scripts/react-general-components/Button";
import { addToBackInStock } from "@app/scripts/utils";

type Props = {
  productId: number;
  variantId: number;
  notifyLabel: string;
};

export const CartNotifyForm: React.FC<Props> = ({ variantId, productId, notifyLabel }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [submitDisabled, setDisabled] = useState<boolean>(true);
  const [email, setEmail] = useState<string>("");
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const handleNotifySubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      const { data: success } = await addToBackInStock({ email, productId, variantId });

      setIsSuccess(success);
    } catch (error) {
      console.error(error);
      setIsSuccess(false);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    setDisabled(email === "");
  }, [email]);

  return (
    <form onSubmit={(e) => handleNotifySubmit(e)} className="cart__line-item__notify-form">
      {isSuccess ? (
        <div>We'll let you know when it's back.</div>
      ) : (
        <>
          <div className="mb-2">
            <span className="font-medium">The size you have selected is sold out.</span> Add your email below and we
            will notify you once back in stock.
          </div>

          <div className="flex flex-col gap-4 md:flex-row">
            <div className="field">
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                required
                disabled={isLoading}
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email Address"
                className="field__input"
              />

              <label htmlFor="email" className="field__label">
                Email Address:{" "}
              </label>
            </div>

            <Button
              type="submit"
              variant="primary"
              disabled={isLoading || submitDisabled}
              ariaLabel={notifyLabel}
              label={notifyLabel}
            ></Button>
          </div>
        </>
      )}
    </form>
  );
};
